// このファイルは設計書（231 プログラム生成元ドキュメント）の表から生成した。手で直すときは設計書と突き合わせること。
// 仕様書 10 章の全メッセージ 306 件（03 フロントエンド設計書 4.3）。「／」は改行に置き換えた（03 4.1）。
// is_used=false は 03 4.5「使わないメッセージ」。辞書には残し、画面では使わない。
// 公開フォームの bot 判定の廃止（2026-09-29 ユーザー判断：インフラ実装メモ X-14）で MSG-E-096 の文言を直し、MSG-V-012・013 は使わなくした。

export const MESSAGES = {
  'MSG-E-001': { text: '${successCount}件削除、${failCount}件失敗しました', is_used: true },
  'MSG-E-002': { text: 'CSVファイルの読み込みに失敗しました', is_used: true },
  'MSG-E-003': { text: 'SES検証メールの送信に失敗しました', is_used: true },
  'MSG-E-004': { text: 'SES検証メール送信に失敗しました', is_used: true },
  'MSG-E-005': {
    text: 'アカウントが一時的にロックされています。しばらく待ってから再度お試しください。',
    is_used: true,
  },
  'MSG-E-006': { text: 'インポート処理中にエラーが発生しました。', is_used: true },
  'MSG-E-007': { text: 'エクスポートに失敗しました', is_used: true },
  'MSG-E-008': { text: 'エラーが発生しました', is_used: true },
  'MSG-E-009': { text: 'エラーが発生しました。', is_used: true },
  'MSG-E-010': { text: 'クリップボードへのコピーに失敗しました', is_used: true },
  'MSG-E-011': { text: 'グループの作成に失敗しました', is_used: false },
  'MSG-E-012': { text: 'このフォームの受付は終了しました。', is_used: true },
  'MSG-E-013': { text: 'このフォームは現在利用できません。', is_used: true },
  'MSG-E-014': { text: 'このフォームは受付上限に達しました。', is_used: true },
  'MSG-E-015': { text: 'このメールアドレスは登録されていません。管理者にお問い合わせください。', is_used: true },
  'MSG-E-018': { text: 'この企業にはメールアドレスが登録されていません', is_used: true },
  'MSG-E-019': { text: 'システムエラーが発生しました。しばらく待ってから再度お試しください。', is_used: true },
  'MSG-E-020': { text: 'システムロールは削除できません', is_used: true },
  'MSG-E-021': { text: 'ステータスの変更に失敗しました', is_used: true },
  'MSG-E-022': { text: 'ステータス更新に失敗しました', is_used: true },
  'MSG-E-023': { text: 'チャットの作成に失敗しました', is_used: true },
  'MSG-E-024': { text: 'データが見つかりません', is_used: true },
  'MSG-E-025': { text: 'データの取得に失敗しました', is_used: true },
  'MSG-E-026': { text: 'データベースエラーが発生しました。しばらく待ってから再度お試しください。', is_used: true },
  'MSG-E-027': { text: 'デフォルトテンプレートの作成に失敗しました', is_used: true },
  'MSG-E-028': { text: 'テンプレートのダウンロードに失敗しました', is_used: true },
  'MSG-E-029': { text: 'テンプレートの削除に失敗しました', is_used: true },
  'MSG-E-030': { text: 'テンプレートの読み込みに失敗しました', is_used: true },
  'MSG-E-031': { text: 'テンプレートの保存に失敗しました', is_used: true },
  'MSG-E-032': { text: 'ファイルサイズが上限を超えています。', is_used: true },
  'MSG-E-033': { text: 'ファイルのアップロードに失敗しました', is_used: true },
  'MSG-E-034': { text: 'ファイルのアップロードに失敗しました。', is_used: true },
  'MSG-E-035': { text: 'ファイルのアップロード準備に失敗しました', is_used: true },
  'MSG-E-036': { text: 'ファイルのダウンロードに失敗しました', is_used: true },
  'MSG-E-037': { text: 'ファイルのダウンロードに失敗しました。', is_used: true },
  'MSG-E-038': { text: 'ファイルの削除に失敗しました', is_used: true },
  'MSG-E-039': { text: 'フォームの読み込みに失敗しました', is_used: true },
  'MSG-E-040': { text: 'フォームの読み込みに失敗しました。', is_used: true },
  'MSG-E-041': { text: 'フォーム情報の読み込みに失敗しました', is_used: true },
  'MSG-E-042': { text: 'メールアドレスが既に使用されています。', is_used: true },
  'MSG-E-043': { text: 'メールの送信に失敗しました', is_used: true },
  'MSG-E-044': { text: 'メモ保存に失敗しました', is_used: true },
  'MSG-E-045': { text: 'メンバーの追加に失敗しました', is_used: false },
  'MSG-E-046': { text: 'ユーザーが見つかりません', is_used: true },
  'MSG-E-047': { text: 'ユーザーの削除に失敗しました。', is_used: true },
  'MSG-E-048': { text: 'ユーザー情報の更新に失敗しました。', is_used: true },
  'MSG-E-049': { text: 'ユーザー情報の読み込みに失敗しました', is_used: true },
  'MSG-E-050': { text: 'レポートの実行に失敗しました', is_used: true },
  'MSG-E-051': { text: 'レポートの読み込みに失敗しました', is_used: true },
  'MSG-E-052': { text: 'ロールが見つかりません', is_used: true },
  'MSG-E-053': { text: 'ロールの読み込みに失敗しました', is_used: true },
  'MSG-E-054': { text: 'ロール一覧の取得に失敗しました', is_used: true },
  'MSG-E-055': { text: '案件が見つかりません', is_used: true },
  'MSG-E-056': { text: '会議記録の保存に失敗しました', is_used: true },
  'MSG-E-057': { text: '回答の取得に失敗しました', is_used: true },
  'MSG-E-058': { text: '回答詳細の読み込みに失敗しました', is_used: true },
  'MSG-E-059': { text: '活動の記録に失敗しました', is_used: true },
  'MSG-E-060': { text: '活動の保存に失敗しました', is_used: true },
  'MSG-E-061': { text: '企業が見つかりません', is_used: true },
  'MSG-E-062': { text: '顧客コードが既に使用されています。', is_used: true },
  'MSG-E-063': { text: '企業の削除に失敗しました。', is_used: true },
  'MSG-E-064': { text: '企業情報の更新に失敗しました。', is_used: true },
  'MSG-E-065': { text: '企業情報の読み込みに失敗しました', is_used: true },
  'MSG-E-066': { text: '企業紐付けに失敗しました', is_used: true },
  'MSG-E-067': { text: '記録の保存に失敗しました', is_used: true },
  'MSG-E-068': { text: '契約が登録されていません', is_used: true },
  'MSG-E-069': { text: '見本テンプレートのダウンロードに失敗しました', is_used: true },
  'MSG-E-070': { text: '個人事業主が見つかりません', is_used: true },
  'MSG-E-071': { text: '顧客コードが既に使用されています。', is_used: true },
  'MSG-E-072': { text: '個人事業主の削除に失敗しました。', is_used: true },
  'MSG-E-073': { text: '個人事業主情報の更新に失敗しました。', is_used: true },
  'MSG-E-074': { text: '個人事業主情報の読み込みに失敗しました', is_used: true },
  'MSG-E-075': { text: '個人事業主紐付けに失敗しました', is_used: true },
  'MSG-E-076': { text: '顧客が見つかりません', is_used: true },
  'MSG-E-077': { text: '顧客が登録されていません', is_used: true },
  'MSG-E-078': { text: '更新に失敗しました', is_used: true },
  'MSG-E-079': { text: '削除に失敗しました', is_used: true },
  'MSG-E-080': { text: '指定されたデータが見つかりませんでした。', is_used: true },
  'MSG-E-081': { text: '主担当の設定に失敗しました', is_used: true },
  'MSG-E-082': { text: '取引が見つかりません', is_used: true },
  'MSG-E-083': { text: '取引の取得に失敗しました', is_used: true },
  'MSG-E-084': { text: '重複するデータが含まれています。', is_used: true },
  'MSG-E-085': { text: '商品の登録に失敗しました', is_used: true },
  'MSG-E-086': { text: '進捗の更新に失敗しました', is_used: true },
  'MSG-E-087': { text: '設定の読み込みに失敗しました', is_used: true },
  'MSG-E-088': { text: '設定の保存に失敗しました', is_used: true },
  'MSG-E-089': { text: '疎通NG (404)：フォームが見つかりません。公開状態をご確認ください。', is_used: true },
  'MSG-E-090': { text: '疎通NG：ネットワークまたは CORS エラーで到達できませんでした。', is_used: true },
  'MSG-E-091': { text: '送信に失敗しました', is_used: true },
  'MSG-E-092': { text: '送信先のメールアドレスが見つかりません', is_used: true },
  'MSG-E-093': { text: '単価変更に失敗しました', is_used: true },
  'MSG-E-094': { text: '担当者更新に失敗しました', is_used: true },
  'MSG-E-095': { text: '電話記録の保存に失敗しました', is_used: true },
  // 243 IE-373：03 4 章 FE-MSG-E-009 の文言に戻す（「・API キー」を付けない）
  'MSG-E-096': {
    text: '到達 (403)：送信元ドメイン制限により拒否されました。許可ドメイン設定をご確認ください。',
    is_used: true,
  },
  'MSG-E-097': {
    text: '到達 (410)：受付終了日を過ぎているか、回答上限に達しています。フォーム設定をご確認ください。',
    is_used: true,
  },
  'MSG-E-098': { text: '認証コードの再送信に失敗しました', is_used: true },
  'MSG-E-099': { text: '認証コードの送信に失敗しました', is_used: true },
  'MSG-E-100': { text: '認証に失敗しました', is_used: true },
  'MSG-E-101': { text: '返信の送信に失敗しました', is_used: true },
  'MSG-E-102': { text: '返信先のメールアドレスが見つかりません', is_used: true },
  'MSG-E-103': { text: '保存に失敗しました', is_used: true },
  'MSG-E-104': { text: '名刺のアップロードに失敗しました', is_used: true },
  'MSG-E-105': { text: '目標が見つかりません', is_used: true },
  'MSG-E-106': { text: '目標の読み込みに失敗しました', is_used: true },
  'MSG-E-107': { text: '優先度更新に失敗しました', is_used: true },
  'MSG-E-108': { text: '要員が登録されていません', is_used: true },
  'MSG-C-001': {
    text: '「${company.company_name}」を削除してもよろしいですか？\nこの操作は取り消すことができません。',
    is_used: true,
  },
  'MSG-C-002': { text: '「${contact.first_name} ${contact.last_name}」を削除してもよろしいですか？', is_used: true },
  'MSG-C-003': { text: '「${file.original_name}」を削除してもよろしいですか？', is_used: true },
  'MSG-C-004': {
    text: '「${form.form_name}」を削除してもよろしいですか？\nこの操作は取り消すことができません。',
    is_used: true,
  },
  'MSG-C-005': { text: '「${goal.goal_name}」を削除しますか？この操作は取り消せません。', is_used: true },
  'MSG-C-006': {
    text: '「${individual.business_owner_name}」を削除してもよろしいですか？\nこの操作は取り消すことができません。',
    is_used: true,
  },
  'MSG-C-007': { text: '「${template.name}」を削除しますか？この操作は取り消せません。', is_used: true },
  'MSG-C-008': {
    text: 'エンドポイントへテスト送信します。\n\nこれは実際のリクエストを送信します。回答項目が無い（または任意のみの）フォームでは、テスト回答が1件記録され、通知先が設定されている場合は通知が送られることがあります。\n\n実行しますか？',
    is_used: true,
  },
  'MSG-C-009': { text: 'この契約を削除してもよろしいですか？', is_used: true },
  'MSG-C-010': { text: 'この取引を削除してもよろしいですか？\nこの操作は取り消すことができません。', is_used: true },
  'MSG-C-011': { text: 'この要員を削除してもよろしいですか？', is_used: true },
  'MSG-C-012': { text: 'ロール「${role.role_name}」を削除してもよろしいですか？', is_used: true },
  'MSG-C-013': { text: '選択した${count}件の契約を削除してもよろしいですか？', is_used: true },
  'MSG-C-014': { text: '選択した${count}件の要員を削除してもよろしいですか？', is_used: true },
  'MSG-C-015': { text: '変更を破棄しますか？', is_used: true },
  'MSG-V-001': { text: '${field.validation.max_length}文字以内で入力してください', is_used: true },
  'MSG-V-002': { text: '${field.validation.max_value}以下の値を入力してください', is_used: true },
  'MSG-V-003': { text: '${field.validation.min_length}文字以上で入力してください', is_used: true },
  'MSG-V-004': { text: '${field.validation.min_value}以上の値を入力してください', is_used: true },
  'MSG-V-005': { text: '${max}文字以下で入力してください', is_used: true },
  'MSG-V-006': { text: '${min}文字以上で入力してください', is_used: true },
  'MSG-V-007': { text: '6桁の数字で入力してください', is_used: false },
  'MSG-V-008': { text: '8桁の数字を入力してください', is_used: true },
  'MSG-V-009': { text: '7桁の数字で入力してください', is_used: false },
  'MSG-V-010': { text: 'CSVファイルの形式が正しくありません。', is_used: true },
  'MSG-V-011': { text: 'CSVファイルを選択してください', is_used: true },
  'MSG-V-012': {
    text: 'reCAPTCHA検証は無効です。有効にする場合は編集画面の「API連携」タブから設定してください。',
    is_used: false,
  },
  'MSG-V-013': {
    text: 'reCAPTCHA検証は有効です。サイトキーを連携先に共有し、シークレットキーはサーバーの環境変数に設定してください。',
    is_used: false,
  },
  'MSG-V-014': { text: 'URLの形式が正しくありません', is_used: false },
  'MSG-V-015': {
    text: 'インボイス番号に使用できない文字が入力されています（半角英数字で入力してください）',
    is_used: false,
  },
  'MSG-V-016': { text: 'インボイス番号の形式が正しくありません（例: T1234567890123）', is_used: true },
  'MSG-V-017': { text: 'インボイス番号は「T」のあとに数字13桁です（英字は使用できません）', is_used: false },
  'MSG-V-018': { text: 'グループ名を入力してください', is_used: false },
  'MSG-V-019': { text: 'このロールの説明を入力してください', is_used: true },
  'MSG-V-020': { text: 'この項目は必須です', is_used: true },
  'MSG-V-021': { text: 'すべての商品にフェーズを設定してください', is_used: true },
  'MSG-V-022': { text: 'セッションが無効になりました。再度ログインしてください。', is_used: true },
  'MSG-V-023': { text: 'タスク名を入力してください', is_used: true },
  'MSG-V-024': { text: 'データソースを選択してください', is_used: true },
  'MSG-V-025': { text: 'テンプレート名を入力してください', is_used: true },
  'MSG-V-026': { text: 'トークンの有効期限が切れています。再度ログインしてください。', is_used: true },
  'MSG-V-027': {
    text: 'ドメインの形式が正しくありません（例: example.co.jp / プロトコルやパスは不要）',
    is_used: true,
  },
  'MSG-V-028': { text: 'ファイルサイズは${Math.floor(maxSize / 1024 / 1024)}MB以内にしてください', is_used: false },
  'MSG-V-029': { text: 'ファイルサイズは10MB以下にしてください', is_used: true },
  'MSG-V-030': { text: 'ファイルサイズは5MB以下にしてください', is_used: true },
  'MSG-V-031': { text: 'ファイルの形式が正しくありません。', is_used: true },
  'MSG-V-032': { text: 'ファイルを選択してください', is_used: true },
  'MSG-V-033': { text: 'フィールドを1つ以上追加してください', is_used: true },
  'MSG-V-034': { text: 'フォームタイトルを入力してください', is_used: true },
  'MSG-V-035': { text: 'フォーム名を入力してください', is_used: true },
  'MSG-V-036': { text: 'マイナンバーは12桁の数字で入力してください', is_used: true },
  'MSG-V-037': {
    text: 'メールアドレスが未検証です。下の「メールアドレスを検証する」ボタンをクリックしてください。',
    is_used: true,
  },
  'MSG-V-038': { text: 'メールアドレスの形式が正しくありません', is_used: true },
  'MSG-V-039': { text: 'メールアドレスは必須です', is_used: true },
  'MSG-V-040': {
    text: 'レポートデータの読み込みに失敗しました。バックエンドAPIがデプロイされているか確認してください。',
    is_used: false,
  },
  'MSG-V-041': { text: 'ロールコードを入力してください', is_used: true },
  'MSG-V-042': { text: 'ロール名を入力してください', is_used: true },
  'MSG-V-043': { text: '宛先を入力してください', is_used: false },
  'MSG-V-044': { text: '案件名を入力してください', is_used: true },
  'MSG-V-045': { text: '会議タイトルを入力してください', is_used: true },
  'MSG-V-046': { text: '会議内容を入力してください', is_used: true },
  'MSG-V-047': { text: '会社名は必須です', is_used: true },
  'MSG-V-048': { text: '開始日と終了日を入力してください', is_used: true },
  'MSG-V-049': { text: '確定金額を入力してください', is_used: false },
  'MSG-V-051': { text: '企業名カナは全角カタカナで入力してください', is_used: true },
  'MSG-V-052': { text: '企業名カナは必須です', is_used: true },
  'MSG-V-053': { text: '企業名は必須です', is_used: true },
  'MSG-V-054': { text: '金額を入力してください', is_used: true },
  'MSG-V-055': { text: '銀行コードは4桁の数字で入力してください', is_used: true },
  'MSG-V-056': { text: '件名を入力してください', is_used: true },
  'MSG-V-058': { text: '顧客と案件名は必須です', is_used: false },
  'MSG-V-059': { text: '顧客を選択してください', is_used: true },
  'MSG-V-060': { text: '口座番号は1～7桁の数字で入力してください', is_used: true },
  'MSG-V-061': { text: '口座番号は7桁以内の数字で入力してください', is_used: false },
  'MSG-V-062': { text: '参加者を入力してください', is_used: false },
  'MSG-V-063': { text: '支店コードは3桁の数字で入力してください', is_used: true },
  'MSG-V-064': { text: '氏名は必須です', is_used: true },
  'MSG-V-065': { text: '事業主名カナは必須です', is_used: true },
  'MSG-V-066': { text: '事業主名は必須です', is_used: true },
  'MSG-V-067': { text: '取引日を入力してください', is_used: true },
  'MSG-V-068': { text: '取引名を入力してください', is_used: true },
  'MSG-V-069': { text: '商品名を入力してください', is_used: true },
  'MSG-V-070': { text: '少なくとも1つの項目を選択してください', is_used: true },
  'MSG-V-071': { text: '招待ユーザーを1人以上選択してください', is_used: false },
  'MSG-V-072': { text: '正しいURL形式で入力してください', is_used: true },
  'MSG-V-073': { text: '正しいメールアドレス形式で入力してください', is_used: true },
  'MSG-V-074': { text: '全角アルファベットは使用できません', is_used: true },
  'MSG-V-075': { text: '全角アルファベットは使用できません。半角で入力してください。', is_used: false },
  'MSG-V-076': { text: '相手を入力してください', is_used: true },
  'MSG-V-077': { text: '単価が変更されていません', is_used: true },
  'MSG-V-078': { text: '担当者姓は必須です', is_used: true },
  'MSG-V-079': { text: '担当者名は必須です', is_used: true },
  'MSG-V-080': { text: '通話内容を入力してください', is_used: true },
  'MSG-V-081': { text: '電話番号の形式が正しくありません', is_used: false },
  'MSG-V-082': { text: '電話番号は10～20文字の数字、ハイフン、括弧で入力してください', is_used: true },
  'MSG-V-083': { text: '内部用のメモを入力してください', is_used: true },
  'MSG-V-084': { text: '入力内容に不備があります。各項目をご確認ください。', is_used: true },
  'MSG-V-085': {
    text: '認証コードが正しくありません。メールに記載されたコードを正確に入力してください。',
    is_used: true,
  },
  'MSG-V-086': { text: '認証コードを入力してください', is_used: true },
  'MSG-V-087': { text: '必須項目です', is_used: true },
  'MSG-V-088': { text: '変更理由を入力してください', is_used: true },
  'MSG-V-089': { text: '返信内容を入力してください...\n画像はCtrl+Vで貼り付けできます', is_used: false },
  'MSG-V-090': { text: '法人番号は13桁の数字で入力してください', is_used: true },
  'MSG-V-091': { text: '本文を入力してください', is_used: true },
  'MSG-V-092': { text: '目標コードを入力してください', is_used: false },
  'MSG-V-093': { text: '目標値を入力してください', is_used: true },
  'MSG-V-094': { text: '目標名を入力してください', is_used: true },
  'MSG-V-095': { text: '有効なURLを入力してください', is_used: true },
  'MSG-V-096': { text: '有効な電話番号を入力してください', is_used: true },
  'MSG-V-097': { text: '郵便番号の形式が正しくありません（例: 123-4567）', is_used: false },
  'MSG-V-098': { text: '郵便番号は123-4567または1234567の形式で入力してください', is_used: true },
  'MSG-S-001': { text: '${email} に認証コードを送信しました', is_used: true },
  'MSG-S-002': { text: '${exportData.length}件のデータをエクスポートしました', is_used: true },
  'MSG-S-003': { text: '${successCount}件のユーザーを削除しました', is_used: true },
  'MSG-S-004': { text: '${successCount}件のロールを削除しました', is_used: true },
  'MSG-S-005': { text: '${successCount}件の案件を削除しました', is_used: true },
  'MSG-S-006': { text: '${successCount}件の企業を削除しました', is_used: true },
  'MSG-S-007': { text: '${successCount}件の契約を削除しました', is_used: true },
  'MSG-S-008': { text: '${successCount}件の個人事業主を削除しました', is_used: true },
  'MSG-S-009': { text: '${successCount}件の顧客を削除しました', is_used: true },
  'MSG-S-010': { text: '${successCount}件の取引を削除しました', is_used: true },
  'MSG-S-011': { text: '${successCount}件の目標を削除しました', is_used: true },
  'MSG-S-012': { text: '${successCount}件の要員を削除しました', is_used: true },
  'MSG-S-013': { text: 'ステータスを「${getStatusLabel(newStatus)}」に変更しました', is_used: true },
  'MSG-S-014': { text: 'ステータスを更新しました', is_used: true },
  'MSG-S-015': { text: 'タスクを完了にしました', is_used: true },
  'MSG-S-016': { text: 'タスクを未完了に戻しました', is_used: true },
  'MSG-S-017': { text: 'データのインポートが正常に完了しました。', is_used: true },
  'MSG-S-018': { text: 'デフォルトテンプレートを${result.created}件作成しました', is_used: true },
  'MSG-S-019': { text: 'テンプレートを削除しました', is_used: true },
  'MSG-S-020': { text: 'テンプレートを保存しました', is_used: true },
  'MSG-S-021': { text: 'ファイルをアップロードしました', is_used: true },
  'MSG-S-022': { text: 'ファイルを削除しました', is_used: true },
  'MSG-S-023': { text: 'ファイルを正常にアップロードしました。', is_used: true },
  'MSG-S-024': { text: 'ファイルを正常に削除しました。', is_used: true },
  'MSG-S-025': { text: 'フォームを削除しました', is_used: true },
  'MSG-S-026': { text: 'メモを保存しました', is_used: true },
  'MSG-S-027': { text: 'ユーザーを正常に削除しました。', is_used: true },
  'MSG-S-028': { text: 'ユーザー情報を正常に更新しました。', is_used: true },
  'MSG-S-029': { text: 'ロールを更新しました', is_used: true },
  'MSG-S-030': { text: 'ロールを作成しました', is_used: true },
  'MSG-S-031': { text: 'ロールを削除しました', is_used: true },
  'MSG-S-032': { text: '企業を削除しました', is_used: true },
  'MSG-S-033': { text: '企業を登録しました。続けてファイルをアップロードできます。', is_used: true },
  'MSG-S-034': { text: '企業情報を正常に更新しました。', is_used: true },
  'MSG-S-035': { text: '企業情報を正常に削除しました。', is_used: true },
  'MSG-S-036': { text: '企業情報を正常に登録しました。', is_used: true },
  'MSG-S-037': { text: '契約を更新しました', is_used: true },
  'MSG-S-038': { text: '契約を削除しました', is_used: true },
  'MSG-S-039': { text: '契約を登録しました', is_used: true },
  'MSG-S-040': { text: '個人事業主を削除しました', is_used: true },
  'MSG-S-041': { text: '個人事業主を登録しました。続けてファイルをアップロードできます。', is_used: true },
  'MSG-S-042': { text: '個人事業主情報を正常に更新しました。', is_used: true },
  'MSG-S-043': { text: '個人事業主情報を正常に削除しました。', is_used: true },
  'MSG-S-044': { text: '個人事業主情報を正常に登録しました。', is_used: true },
  'MSG-S-045': { text: '採番ルールを保存しました', is_used: true },
  'MSG-S-046': { text: '主担当に設定しました', is_used: true },
  'MSG-S-047': { text: '主担当を解除しました', is_used: true },
  'MSG-S-048': { text: '取引を削除しました', is_used: true },
  'MSG-S-049': { text: '処理が正常に完了しました。', is_used: true },
  'MSG-S-050': { text: '進捗を更新しました', is_used: true },
  'MSG-S-051': { text: '正常にログアウトしました。', is_used: true },
  'MSG-S-052': { text: '設定を保存しました', is_used: true },
  'MSG-S-053': {
    text: '疎通OK (400)：エンドポイントに到達し、サーバー側の入力検証が応答しました（必須項目未入力のため保存はされていません）。',
    is_used: true,
  },
  'MSG-S-054': { text: '送信が完了しました。', is_used: true },
  'MSG-S-055': { text: '送信が完了しました。ありがとうございます。', is_used: true },
  'MSG-S-056': { text: '送信しました', is_used: true },
  'MSG-S-057': { text: '単価を変更しました', is_used: true },
  'MSG-S-058': { text: '担当者を更新しました', is_used: true },
  'MSG-S-059': { text: '担当者を削除しました', is_used: true },
  'MSG-S-060': { text: '担当者を追加しました', is_used: true },
  'MSG-S-061': { text: '返信を送信しました', is_used: true },
  'MSG-S-062': { text: '目標を更新しました', is_used: true },
  'MSG-S-063': { text: '目標を作成しました', is_used: true },
  'MSG-S-064': { text: '目標を削除しました', is_used: true },
  'MSG-S-065': { text: '優先度を更新しました', is_used: true },
  'MSG-S-066': { text: '要員を削除しました', is_used: true },
  'MSG-S-067': { text: '要員を登録しました', is_used: true },
  'MSG-S-068': { text: '要員情報を更新しました', is_used: true },
  'MSG-I-001': { text: 'CSVファイルにデータがありません', is_used: true },
  'MSG-I-002': { text: 'お問い合わせがありません', is_used: true },
  'MSG-I-003': { text: 'この案件で登録されている商品はまだありません', is_used: true },
  'MSG-I-004': { text: 'この操作を実行する権限がありません。管理者にお問い合わせください。', is_used: true },
  'MSG-I-005': { text: 'チェックリストがありません', is_used: true },
  'MSG-I-006': { text: 'データがありません', is_used: true },
  'MSG-I-007': { text: 'デフォルトテンプレートは既に存在します', is_used: true },
  'MSG-I-008': { text: 'ファイルのアップロード完了までお待ちください', is_used: true },
  'MSG-I-009': { text: 'フォームがありません', is_used: true },
  'MSG-I-010': { text: 'メールアドレスは半角英数字とハイフンのみ使用できます', is_used: false },
  'MSG-I-011': { text: 'メモはありません', is_used: true },
  'MSG-I-012': { text: '回答がありません', is_used: true },
  'MSG-I-013': { text: '該当する顧客がありません', is_used: true },
  'MSG-I-014': { text: '該当する商品がありません', is_used: true },
  'MSG-I-015': { text: '監査ログがありません', is_used: true },
  'MSG-I-016': { text: '企業がありません', is_used: true },
  'MSG-I-017': { text: '検索結果がありません', is_used: true },
  'MSG-I-018': { text: '公開後に実行できます', is_used: true },
  'MSG-I-019': { text: '疎通OK (${res.status})：エンドポイントに到達し、送信が受理されました。', is_used: true },
  'MSG-I-020': { text: '登録されている企業がありません', is_used: true },
  'MSG-I-021': { text: '登録されている個人事業主がありません', is_used: true },
} as const;

export type MessageId = keyof typeof MESSAGES;
